import React, { useEffect, useState } from 'react';
import { Globals } from '../../global/Globals';
import './UnsolicitedCreateFooter.css';
import { useSelector } from 'react-redux';
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';

const UnsolicitedCreateFooter = ({ onCancelCreate,onSaveDraft, onSubmit, isButtonEnabled, isSaveDraftButtonEnabled }) => {
    const { Globals ,languages, setLanguages } = useLanguage();
    const [btnClassName, setBtnClassName] = useState(["draft-disabled-btn","unsolicited-disabled-btn"]);
   // const isAgreementChecked = useSelector(state => state.termsConditions.isAgreementChecked);
   // const isPolicyChecked = useSelector(state => state.termsConditions.isPolicyChecked);
    //const isButtonEnabled=isAgreementChecked&&isPolicyChecked?true:false;
    useEffect(() => {
        if (isButtonEnabled) {
            setBtnClassName(['cancel-reg-btn save-draft-btn','unsolicited-ftr-register-btn-active'])
        }
        else if(isSaveDraftButtonEnabled){
            setBtnClassName(['cancel-reg-btn save-draft-btn',"unsolicited-disabled-btn"]);
        }
        else{
            setBtnClassName(["draft-disabled-btn","unsolicited-disabled-btn"]);
        }
    },[isButtonEnabled, isSaveDraftButtonEnabled]);
    const cancelRegistration = () => {
        if (onCancelCreate) {
            onCancelCreate();
        }
    }

    
    return (
        <div id="register-footer" className="register-footer">
            <div className="register-footer-btn-frame">
                <div className="reg-footer-btn-group">
                    <span className="cancel-reg-btn" onClick={cancelRegistration}>{Globals.HALF_PAGE_BRIEF_DETAILS.CANCEL || FallBackLabel.HALF_PAGE_BRIEF_DETAILS.CANCEL}</span>
                    <button onClick={onSaveDraft} id="action-button " className={btnClassName[0]} >{Globals.SAVE_AS_DRAFT || FallBackLabel.SAVE_AS_DRAFT}</button>
                    <button onClick={onSubmit} id="register-submit-btn" className={btnClassName[1]}>{Globals.SUBMIT_PROPOSAL || FallBackLabel.SUBMIT_PROPOSAL }</button>
                </div>
            </div>
        </div>
    );
}
export default UnsolicitedCreateFooter;